'use client'

import {
  type ReactNode,
  type UIEvent,
  createContext,
  useContext,
  useState,
} from 'react'
import { useSidebarLayoutContext } from './use-sidebar-layout.ts'

type SidebarLayoutMainProps = {
  children: ReactNode
}

const ScrollContext = createContext<{ scrollY: number }>({
  scrollY: 0,
})

const useScroll = () => useContext(ScrollContext)

const SidebarLayoutMain = ({ children }: SidebarLayoutMainProps) => {
  const [scrollY, setScrollY] = useState<number>(0)
  const { setMainScrollRef } = useSidebarLayoutContext()

  const handleScroll = (event: UIEvent<HTMLDivElement>) => {
    setScrollY(event.currentTarget.scrollTop)
  }

  return (
    <ScrollContext.Provider value={{ scrollY }}>
      <div
        ref={setMainScrollRef}
        onScroll={handleScroll}
        className="relative lg:pl-20 overflow-auto h-full stable-scroll"
      >
        {children}
      </div>
    </ScrollContext.Provider>
  )
}

export { SidebarLayoutMain, useScroll }
